<app-navbar></app-navbar>
<router-outlet></router-outlet>
<!-- <msal-redirect></msal-redirect> -->
@if (authLoading()) {
	<div class="auth-overlay">
		<div class="auth-spinner">
			<div class="ring"></div>
			<span>Signing in...</span>
		</div>
	</div>
}
